/**
Custom Hook useTargetRef for Adobe Target
*/
import React, { useRef, useEffect } from "react"
import document from "global/document";

function useTargetRef (location){
	const atRef = useRef(null);
    
    const triggerLocations = (location) => {
        window.adobe.target.ext.triggerLocations([location]).then(
            function(offer) { 
                console.log("AT: Prefetched Location", offer);
                if (atRef && atRef.current && offer) {
                    atRef.current.innerHTML = offer;
                    console.log('did set ref', atRef.current.innerHTML);
                }
            },
            function (error){
                console.log("AT: Prefetched Location Error",error);
            }
        );
    }

	// simulate componentDidMount
	useEffect(() => {
        console.log('in useAdobeTarget render once', location);
		
        // Use Prefetch Locations extension
        if(typeof "adobe" !== "undefined" && "target" in window.adobe && 
            typeof "adobe.target.ext" !== "undefined" && typeof window.adobe.target.ext.triggerLocations === "function"
        ){
            triggerLocations(location);
        }else{
            document.addEventListener("atx-prefetched-locations-loaded", (event) => {
                console.log("AT: useTargetRef: at-library-loaded", event);
                triggerLocations(location);
            });
        }
    }, []);
	return atRef;
}

export default useTargetRef;